export default __webpack_public_path__ + "static/media/project-two.b5277efa.png";